import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { ELineStyle } from '@common/enums';
import { ThemeStateService } from '@sites/site-theme/src/state';
import type { CatalogCategoriesView } from '@web/widgets/catalog-products/type';
import { type FilterFormGroup, type FilterFormType } from '@web/widgets/catalog-products/type';

import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { FilterCategorySettingsComponent } from './category-settings/filter-category-settings.component';
import { FilterGeneralSettingsComponent } from './general-settings/filter-general-settings.component';
import { FilterPriceSettingsComponent } from './price-settings/filter-price-settings.component';

@Component({
    selector: 'web-filter-settings',
    templateUrl: './filter-settings.component.html',
    styleUrls: ['./filter-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonElementsModule,
        FilterCategorySettingsComponent,
        FilterGeneralSettingsComponent,
        FilterPriceSettingsComponent,
    ],
})
export class FilterSettingsComponent extends WebBaseControlTypedSettingsComponent<FilterFormGroup> {
    @Input() catalogView: CatalogCategoriesView;

    private readonly themeState = inject(ThemeStateService);

    public readonly selectedThemeColors = this.themeState.selectedColors;

    public get generalFormGroup(): FilterFormType['general'] {
        return this.itemForm.get('general') as FilterFormType['general'];
    }

    public get categoryFormGroup(): FilterFormType['category'] {
        return this.itemForm.get('category') as FilterFormType['category'];
    }

    public get priceFormGroup(): FilterFormType['price'] {
        return this.itemForm.get('price') as FilterFormType['price'];
    }

    protected readonly lineStyle = ELineStyle;
}
